export const checkoutUrl = 'https://tu-boda-en-paz.impultienda.ar/checkout'

export const totalValue = '$244.000'
export const priceToday = '$25.990'

export const pains = [
  {
    title: 'El miedo al silencio incómodo',
    body: 'Esas mesas donde nadie se conoce y solo hay miradas bajas y celulares en la mano.',
  },
  {
    title: 'El estrés de los “tiempos muertos”',
    body: 'Ese bache de energía entre la ceremonia y la cena que puede matar la fiesta.',
  },
  {
    title: 'Niños corriendo sin control',
    body: 'Padres estresados que se van temprano porque sus hijos no tienen nada que hacer.',
  },
  {
    title: 'Tú, agotada',
    body: 'Tratando de coordinar cada detalle en lugar de disfrutar el día por el que pagaste una fortuna.',
  },
]

export type Offer = {
  label: string
  title: string
  items: string
  value: string
}

export const modules: Offer[] = [
  {
    label: 'Módulo 1',
    title: 'Rompehielos Interactivos',
    items: 'Sopas de letras, Bingo de fotos y crucigramas personalizados para los primeros minutos.',
    value: '$45.000',
  },
  {
    label: 'Módulo 2',
    title: 'Juegos de Mesa “Table Fun”',
    items: 'Quién conoce mejor a los novios, Predicciones, Él dijo / Ella dijo.',
    value: '$35.000',
  },
  {
    label: 'Módulo 3',
    title: 'Kit Infantil “Mini Invitado”',
    items: 'Libros de actividades, I-Spy de boda y laberintos para los más pequeños.',
    value: '$25.000',
  },
  {
    label: 'Módulo 4',
    title: 'El Protocolo “Calm Bride”',
    items: 'Checklists de emergencia y cronograma de actividades minuto a minuto.',
    value: '$45.000',
  },
  {
    label: 'Módulo 5',
    title: 'Cartelería y Comunicación Estética',
    items: 'Diseños editables en Canva para cada rincón de tu celebración.',
    value: '$25.000',
  },
]

export const bonuses: Offer[] = [
  {
    label: 'Bono #1',
    title: 'Guion de presentaciones para la fiesta',
    items: 'Qué decir y en qué orden: entrada, brindis, baile y agradecimientos, palabra por palabra.',
    value: '$15.000',
  },
  {
    label: 'Bono #2',
    title: 'Plan de música y momentos clave',
    items: 'Qué suena en cada tramo de la noche para que la energía nunca se caiga.',
    value: '$15.000',
  },
  {
    label: 'Bono #3',
    title: 'Rondas y dinámicas para integrar a todos',
    items: 'Actividades guiadas que mezclan familias y amigos sin que nadie se sienta expuesto.',
    value: '$14.000',
  },
  {
    label: 'Bono #4',
    title: 'El “Salvavidas de Mesa”',
    items: 'Recursos rápidos para rescatar cualquier mesa apagada en menos de dos minutos.',
    value: '$13.000',
  },
  {
    label: 'Bono #5',
    title: 'El “Plan de Escape” de la Novia',
    items: 'Tu protocolo para respirar, retocarte y volver renovada sin que la fiesta se detenga.',
    value: '$12.000',
  },
]

export const faqs = [
  {
    q: 'No sé nada de diseño, ¿puedo usarlo?',
    a: '¡Sí! Todo está en Canva. Solo haces clic, cambias los nombres y descargas. Es más fácil que escribir un post en Facebook.',
  },
  {
    q: 'Mi boda es de un color específico, ¿puedo cambiarlo?',
    a: 'Absolutamente. Todos los colores y fuentes son editables en 2 clics.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No, es un producto digital de descarga inmediata. Lo compras ahora y en 30 segundos puedes estar imprimiéndolo. Sin esperas de envío.',
  },
  {
    q: '¿Sirve para bodas pequeñas?',
    a: '¡Es incluso mejor! Ayuda a que los grupos pequeños rompan el hielo mucho más rápido.',
  },
]
